import { EventTypeEnum } from "shared/types";

import { DETAILS_RELATED_EVENTS_ID } from "pages/Dashboard/components/constants";
import { LandingPageEventType } from "pages/Dashboard/types";
import { RelatedEventGroup } from "pages/shared/Dashboard/types";

import LinkButton from "features/ui/LinkButton";

const getEventCountString = (
  event: LandingPageEventType,
  relatedEvents: RelatedEventGroup
) => {
  if (
    relatedEvents.eventType === EventTypeEnum.CLAIM &&
    "matchedClaimsCount" in event
  ) {
    return event.matchedClaimsCount && event.matchedClaimsCount > 0
      ? event.matchedClaimsCount + " "
      : "";
  }

  if (
    "matchedEventCounts" in event &&
    (!relatedEvents.signalEventType ||
      !event.matchedEventCounts ||
      !event.matchedEventCounts[relatedEvents.signalEventType])
  ) {
    return "";
  }

  if (
    "matchedEventCounts" in event &&
    event.matchedEventCounts &&
    relatedEvents.signalEventType
  ) {
    return event.matchedEventCounts[relatedEvents.signalEventType] + " ";
  }

  return "";
};

interface RelatedEventProps {
  event: LandingPageEventType;
  relatedEvent: RelatedEventGroup;
  index: number;
}

const RelatedEvent = ({ relatedEvent, index, event }: RelatedEventProps) => {
  const eventCountString = getEventCountString(event, relatedEvent);

  if (!eventCountString) {
    return null;
  }

  const elementId = `${DETAILS_RELATED_EVENTS_ID}-${index}`;

  const handleClick = () => {
    const element = document.getElementById(elementId);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <LinkButton
      key={relatedEvent.title + `_${index}`}
      data-testid={`qv-related-event-${index}`}
      className="cursor-pointer"
      onClick={handleClick}
    >
      <span className="font-bold">{eventCountString}</span>
      {relatedEvent.title}
    </LinkButton>
  );
};

export default RelatedEvent;
